import { htmlToText } from "lib/html-to-text"
import { replaceMacroTokensInString } from "authoring/routes/macro/lib/macro-text-utils"
import { stripNonContentElements } from "./strip-non-content-elements"

export const CONTENT_PREVIEW_LENGTH = 140

export function buildContentPreview(content = "", previewLength = CONTENT_PREVIEW_LENGTH) {
    const text = contentToPlainText(content)
    if (text.length <= previewLength) return text
    return `${text.slice(0, previewLength).trimEnd()}...`
}

export function hasLongContent(content = "", previewLength = CONTENT_PREVIEW_LENGTH) {
    return contentToPlainText(content).length > previewLength
}

function contentToPlainText(content) {
    return htmlToText(stripNonContentElements(content), true).replace(/\n+/g, " ").trim()
}

/**
 * Expands macro tokens in the content and returns a plain-text preview.
 * Falls back to the raw content preview when no macroMap is provided.
 */
export function buildExpandedContentPreview(content = "", macroMap, previewLength = CONTENT_PREVIEW_LENGTH) {
    if (!macroMap || !Object.keys(macroMap).length) {
        return buildContentPreview(content, previewLength)
    }

    const expanded = replaceMacroTokensInString({
        textOrHtml: content,
        macrosById: macroMap,
    })

    return buildContentPreview(expanded, previewLength)
}
